// Browsers phrase this differently, but it's always the same condition: a hashed
// asset the page references no longer exists on the server (typically because a
// new deploy overwrote it after the browser loaded an older index.html).
const CHUNK_LOAD_ERROR_PATTERNS = [
  'failed to fetch dynamically imported module', // Chromium
  'error loading dynamically imported module', // Firefox
  'importing a module script failed', // Safari
];

export const isChunkLoadError = (err: unknown) =>
  err instanceof Error &&
  CHUNK_LOAD_ERROR_PATTERNS.some((pattern) =>
    err.message.toLowerCase().includes(pattern)
  );
